import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import TextInput from './../TextInput';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';
import Icon from "../Icon";
import Button from "../Button";
import debounce from "../../../utils/debounce";
import {postData, postRequest} from "../../../utils/request";
import parse_url from "locutus/php/url/parse_url";
import {unparse_url} from "../../../utils/url/unparse_url";

class TaxId extends React.Component {

    state = {
        response: null
    }

    componentDidMount() {
        this.loadPartnerData();
    }

    loadPartnerData = debounce(async () => {
        if (this.props.value?.[this.props.name || "taxid"] && this.props.value?.address?.country) {
            let data = {
                taxpayer_type: "corporate",
                taxid: this.props.value?.[this.props.name || "taxid"],
                country: this.props.value?.address?.country,
            };
            try {
                const response = await postRequest({
                    action: 'partner.lookup_taxnum',
                    ...data,
                });
            
                if (!!response.group_partner && !!this.props.value.taxid) {
                    this.props.setFieldValue("group_taxid", this.props.value?.[this.props.name || "taxid"])
                }
                this.setState({response});
            } catch (response) {
                this.setState({response});
            }
        }
    }, 300);

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.value?.[this.props.name || "taxid"] !== prevProps.value?.[prevProps.name || "taxid"]
            ||
            this.props.value?.address?.country !== prevProps.value?.address?.country
        ) {
            this.loadPartnerData();
        }
    }

    render() {
        let props = {...this.props};
        let href = parse_url(window.location.href);
        href.fragment = "/?option=partner&partner_id=" + this.state.response?.partner?.partner_id;
        href = unparse_url(href);
        const errorMsg = this.props.error || (!this.state.response?.success ? this.state.response?.msg : (this.state.response?.partner?.partner_id && this.props.value?.partner_id + "" !== "" + this.state.response?.partner?.partner_id && <Fragment>
            Ez az adószám már rögzítve van a(z) <a href={href} onClick={(e) => {
            e && e.preventDefault();
            window.open(href, '_blank');
        }}>{this.state.response?.partner?.name}</a> partnerhez!
        </Fragment>));
        if (props.parent) {
            return <TextInput
                {...props}
                name={this.props.name || "taxid"}
                value={this.props.value[this.props.name || "taxid"]}
                error={errorMsg}
            />
        } else {
            return <div className="col-sm-6">
                <label className="control-label">Adószám</label>
                <div className="input-group">
                    <TextInput
                        {...props}
                        error={!!this.props.error || !!errorMsg}
                        warning={!!this.props.warning}
                        valid={!!this.props.valid}
                        name={this.props.name || "taxid"}
                        value={this.props.value[this.props.name || "taxid"]}
                        label={false}
                    />
                    <div className="input-group-btn">
                        <Button tag="a" tooltip="Nemzeti Cégtár" href="https://nemzeticegtar.hu/nemzeticegtar/" target="_blank" className="btn btn-default"><Icon lib="fas" name="search"/></Button>
                    </div>
                </div>
                {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}
                {this.props.warning && <div className="warning-feedback">{this.props.warning}</div>}
                {this.props.valid && <div className="valid-feedback">{this.props.valid}</div>}
            </div>
        }
    }
}

class CompanyControl extends React.Component {

    constructor(props) {
        super(props);
        this.getLayout = this.getLayout.bind(this)
    }

    fieldProps = (fields, name) => {
        const props = (Array.isArray(fields)) ? {} : (fields[name] || {});
        const def = this.props.props && this.props.props[name] || this.props[name] || null;
        if(def) {
            if(def.disabled) {
                if(typeof def.disabled === "object") {
                    props.disabled = props.disabled || get(def.disabled, name, false);
                } else {
                    props.disabled = props.disabled || def.disabled;
                }
            }
        }
        if(this.props.disabled) {
            if(typeof this.props.disabled === "object") {
                props.disabled = props.disabled || get(this.props.disabled, name, false);
            } else {
                props.disabled = props.disabled || this.props.disabled;
            }
        }
        return props;
    }

    setFieldValue = (field, value) => {
        if (field.indexOf("taxid") !== -1) {
            if (value === '') {
                value = null;
            }
        }
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue, value)) {
            const v = Object.assign({}, this.props.value);
            set(v, field, value);
            this.setState({
                ...this.state
            });
            this.props.saveChanges((this.props.name || 'company'), v);
        }
    }

    saveChanges = (field, value) => {
        if (field.indexOf("taxid") !== -1) {
            if (value === '') {
                value = null;
            }
        }
        if(this.props.name) {
            this.setFieldValue(field, value);
        } else {
            this.props.saveChanges(field, value);
        }
    }

    // https://gist.github.com/ecarter/1423674
    mapOrder = (array, order, key) => {

        array.sort( function (a, b) {
            var A = a[key], B = b[key];

            if (order.indexOf(A) > order.indexOf(B)) {
                return 1;
            } else {
                return -1;
            }

        });

        return array;
    };

    getLayout(fields) {
        const nameFieldDef = this.fieldProps(fields, "name");
        let name = null;
        if(nameFieldDef.parent) {
            name = <TextInput  {...nameFieldDef} name="name" value={this.props.value.name || ''}
                           label="Név" saveChanges={ this.saveChanges }/>
            ReactDOM.createPortal(name, nameFieldDef.parent);
        } else {
            name = <div  className="col-sm-12">
                <TextInput {...nameFieldDef} name="name" value={this.props.value.name || ''}
                           label="Név" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const taxidFieldDef = this.fieldProps(fields, "taxid");
        const taxid = <TaxId
            {...taxidFieldDef}
            name="taxid"
            value={this.props.value}
            label="Adószám"
            setFieldValue={this.props.setFieldValue}
            saveChanges={this.saveChanges}
        />
        const eu_taxidFieldDef = this.fieldProps(fields, "eu_taxid");
        let eu_taxid = null;
        if(eu_taxidFieldDef.parent) {
            eu_taxid = <TextInput {...eu_taxidFieldDef} name="eu_taxid" value={this.props.value.eu_taxid || ''}
                               label="EU Adószám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(eu_taxid, eu_taxidFieldDef.parent);
        } else {
            eu_taxid = <div className="col-sm-6">
                <TextInput {...eu_taxidFieldDef} name="eu_taxid" value={this.props.value.eu_taxid || ''}
                           label="EU Adószám" saveChanges={ this.saveChanges }/>
            </div>;
        }

        const group_idFieldDef = this.fieldProps(fields, "group_id");
        let group_id = null;
        if(group_idFieldDef.parent) {
            group_id =  this.props.value["taxid"] === undefined || this.props?.value?.taxid == null ?
            <TextInput {...group_idFieldDef} name="group_id" value={this.props.value.group_id || ''}
                               label="Csoport azonosító" saveChanges={ this.saveChanges }/> : null
            //ReactDOM.createPortal(group_id, group_idFieldDef.parent);
        } else {
            group_id = this.props.value["taxid"] === undefined || this.props?.value?.taxid == null ?
             <div className="col-sm-6">
                <TextInput {...group_idFieldDef} name="group_id" value={this.props.value.group_id || ''}
                           label="Csoport azonosító" saveChanges={ this.saveChanges }/>
            </div> : null;
        }


        const group_taxidFieldDef = this.fieldProps(fields, "group_taxid");
        let group_taxid = null;
        if(eu_taxidFieldDef.parent) {
            group_taxid = <TextInput {...group_taxidFieldDef} name="group_taxid" value={this.props.value.group_taxid || ''}
                               label="Csoportos adószám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(group_taxid, group_taxidFieldDef.parent);
        } else {
            group_taxid = <div className="col-sm-6">
                <TextInput {...group_taxidFieldDef} name="group_taxid" value={this.props.value.group_taxid || ''}
                           label="Csoportos adószám" saveChanges={ this.saveChanges }/>
            </div>;
        }

        const emailFieldDef = this.fieldProps(fields, "email");
        let email = null;
        if(emailFieldDef.parent) {
            email = <TextInput {...emailFieldDef} name="email" value={ this.props.value.email } label="Email" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(email, emailFieldDef.parent);
        } else {
            email = <div className="col-md-6">
                <TextInput {...emailFieldDef} name="email" value={ this.props.value.email } label="Email" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const telnumFieldDef = this.fieldProps(fields, "telnum");
        let telnum = null;
        if(telnumFieldDef.parent) {
            telnum = <TextInput {...telnumFieldDef} name="telnum" value={ this.props.value.telnum } label="Telefonszám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(telnum, telnumFieldDef.parent);
        } else {
            telnum = <div className="col-md-6">
                <TextInput {...telnumFieldDef} name="telnum" value={ this.props.value.telnum } label="Telefonszám" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const fieldnames = (Array.isArray(fields)) ? fields : Object.keys(fields);
        const map = this.mapOrder([
            {field: /*nameFieldDef.parent === undefined && */fieldnames.indexOf("name") !== -1 ? name : null, name: "name"},
            {field: /*taxidFieldDef.parent === undefined && */fieldnames.indexOf("taxid") !== -1 ? taxid : null, name: "taxid"},
            {field: /*eu_taxidFieldDef.parent === undefined && */fieldnames.indexOf("eu_taxid") !== -1 ? eu_taxid : null, name: "eu_taxid"},
            {field: /*emailFieldDef.parent === undefined && */fieldnames.indexOf("email") !== -1 ? email : null, name: "email"},
            {field: /*telnumFieldDef.parent === undefined && */fieldnames.indexOf("telnum") !== -1 ? telnum : null, name: "telnum"},
            {field: /*emailFieldDef.parent === undefined && */fieldnames.indexOf("group_id") !== -1 ? group_id : null, name: "group_id"},
            {field: /*telnumFieldDef.parent === undefined && */fieldnames.indexOf("group_taxid") !== -1 ? group_taxid : null, name: "group_taxid"},
        ], (Array.isArray(fields)) ? fields : Object.keys(fields), 'name');
        return map.filter((item) => item.field !== null).map((item, idx) => <item.field.type key={idx} {...item.field.props} />);
    }

    render() {
        const fields = this.props.fields || ["name"];
        return this.props.layout ? this.props.layout(fields) : this.getLayout(fields);
    }

}

export default CompanyControl;